<template>
    <el-row>
      <el-col :span="24">
        <el-button style="float: left" size="mini" type="primary" @click="newChargersVisiableFunc()">{{ $t('charger.new', { msg: 'charger.new' }) }}</el-button>
        
        <div style=" width: 800px;margin-bottom:10px; float: right;">
        <el-select size="mini" v-model="selectfunc" placeholder="请选择" style="margin-right: 10px;width: 100px; ">
          <el-option
            v-for="item in allselectfunc"
            :key="item.label"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input v-model="search" size="mini" :placeholder="$t('charger.search', { msg: 'charger.search' })" style=" width: 500px;margin-bottom:10px;"/>
            <el-button  size="mini" type="primary" @click="getChargersList()">{{ $t('kbinfo.select', { msg: 'kbinfo.select' }) }}</el-button>
            <el-button  type="danger" size="mini" @click="reset()">{{ $t('charger.reset', { msg: 'charger.reset' }) }}</el-button>
        </div>
      </el-col>
    </el-row>
    <el-table tooltip-effect="dark"
              style="width: 100%"
              stripe
              highlight-current-row
              border
              v-loading="loading"
              :data="chargerList"
              ref="chargerTable"
              :header-cell-style="{background:'#eef1f6',color:'#606266'}"
            >
      <el-table-column :label="$t('charger.table.charger', { msg: 'charger.table.charge' })" prop="name"></el-table-column>
      <el-table-column :label="$t('charger.table.chargeCompany', { msg: 'charger.table.chargeCompany' })" prop="companyName"></el-table-column>
      <el-table-column :label="$t('charger.table.type', { msg: 'charger.table.type' })" prop="type"></el-table-column>
      <el-table-column :label="$t('charger.table.opr', { msg: 'charger.table.opr' })" prop="operation">
        <template #default="scope">
            <el-button size="mini" type="danger" @click="delChargers(scope.$index, scope.row.id)">{{ $t('charger.delete', { msg: 'charger.delete' }) }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
        :title="$t('charger.new', { msg: 'charger.new' })"
        v-model="newChargersVisiable"
        width="50%"
        :before-close="newCompanyDialogClose">
    <el-form ref='chargerForm' :model="chargerForm">
        <el-form-item prop="companyName" :rules="{required: true, message: this.$t('charger.companyInCharge', { msg: 'charger.companyInCharge' }), trigger: 'blur'}">
          <el-select type="text" :placeholder="$t('charger.companyInCharge', { msg: 'charger.companyInCharge' })"
           v-model="chargerForm.companyName" 
           style="width:400px" 
           ref="companySelect" 
           @change="handelCompanyChange()"
           >
            <el-option v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                @click="companyChange(item.value)"
                ref="companyOption">
            </el-option>
        </el-select>
        </el-form-item>
        <el-form-item prop="type" :rules="{required: true, message: this.$t('charger.typeS', { msg: 'charger.typeS' }), trigger: 'blur'}">
          <el-select 
          type="text" 
          :placeholder="$t('charger.typeS', { msg: 'charger.typeS' })" 
          v-model="chargerForm.type" 
          style="width:400px" 
          ref="type">
              <el-option v-for="item in typeList"
              :key="item.text"
              :label="item.label"
              :value="item.value">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="name" :rules="{required: true, message: this.$t('charger.personInCharge', { msg: 'charger.personInCharge' }), trigger: 'blur'}">
          <el-select 
          type="text" 
          :placeholder="$t('charger.personInCharge', { msg: 'charger.personInCharge' })" 
          v-model="chargerForm.name" 
          style="width:400px" 
          ref="username">
              <el-option v-for="item in usernameList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
          </el-select>
        </el-form-item>     

      <el-form-item>
        <el-button type="primary" @click="addCharger()">{{ $t('charger.create', { msg: 'charger.create' }) }}</el-button>
        <el-button type="danger" @click="resetForm('chargerForm')">{{ $t('charger.reset', { msg: 'charger.reset' }) }}</el-button>
    </el-form-item>
    </el-form>
    </el-dialog>
  
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[2,10,20,100,1000]"
      :page-size="pageSize"
      :total="totalRow"
      layout="sizes, total, prev, pager, next, jumper"
    ></el-pagination>
  </template>


  <script>
  import axios from 'axios';
  import { baseUrl_New } from '../../axios/urlconfig';
  import { deleteRequest, getRequest, postRequest } from '../../axios/axios';

  export default{
      data(){
          return{
            chargerForm:{
                companyID: '',
                name: '',
                companyName: '',
                type: '',
            },
            companyList: [],
            usernameList: [],
            typeList: [],
            newChargersVisiable: false,
            chargerList: [],
            totalRow: 0, //总数据量
            currentChargerList: [], // 当前显示的数据页
            currentPage: 1, // 当前页码
            pageSize: 10, // 每页显示的数据条数
            allselectfunc: [{
            label: this.$t('issue.table.cus', { msg: 'issue.table.cus' }),
            value: 'username'
            },{
            label: this.$t('charger.table.chargeCompany', { msg: 'charger.table.chargeCompany' }),
            value: 'companyName'
            }],
            search: '',
            selectfunc: "username",
          }
      },

      created(){
          this.getChargersList();
          this.getAllCompany();
      },

      methods:{
        // selectFunc(){
        //   const pageNum = this.currentPage;
        //   console.log(this.currentPage);
        //   const pageSize = this.pageSize;
        //   console.log(this.pageSize);
        //   const fieldName = this.selectfunc;
        //   const fieldValue = this.search;
        //   const params = { fieldName,fieldValue,pageNum, pageSize };
        //   axios.get(baseUrl_New + '/charger/select/' + fieldName + '/' + fieldValue + '/' + pageNum + '/' + pageSize).then(response => {
        //     // axios.get(baseUrl_New + '/charger/select/' + fieldName + '/' + fieldValue).then(response => {
        //       this.chargerList = response.data.list;
        //       this.totalRow = response.data.total
        //   }).catch(err => {
        //     console.log(err);
        //   })
        // },

        handleCurrentChange(currentPage) {
        this.currentPage = currentPage;
        this.getChargersList();
      },
  
       // 处理分页组件的每页显示条数改变事件
       handleSizeChange(pageSize) {
        this.pageSize = pageSize;
        this.getChargersList();
      },
  
       //更新当前显示的数据页
       updateCurrentChargersList() {
          if (!Array.isArray(this.chargerList)) {
          this.chargerList = []; // 如果不是数组，则初始化为空数组
          }
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        this.currentChargerList = this.chargerList.slice(startIndex, endIndex);
      },

       getChargersList(){
           this.loading = true;
          const pageNum = this.currentPage;
          const pageSize = this.pageSize;
          const fieldName = this.selectfunc;
          const fieldValue = this.search;
          let params = { pageNum, pageSize};
          if(fieldValue !== null && fieldValue !== undefined && fieldValue !== ''){
            params = { pageNum, pageSize, fieldName, fieldValue };
          }
              getRequest(baseUrl_New + '/charger/list',  params ).then(response => {
              console.log(response);
              this.chargerList = response.list; // 确保数据在 response.data.list 中
              this.totalRow = response.total; // 确保总数据量在 response.data.total 中
              this.chargerList = response.list.map(item => ({
            ...item,
          }))
              this.updateCurrentChargersList(); // 加载数据后更新当前显示的数据页
              this.loading = false;
          }).catch(err => {
            this.$message.error(this.$t('charger.info', { msg: 'charger.info' }))
          })
      },

      delChargers(index,id){
        this.$confirm(this.$t('agent.deleteDF', { msg: 'agent.deleteDF' }), this.$t('issue.tips', { msg: 'issue.tips' }),{
        confirmButtonText: this.$t('exportIssue.confirm', { msg: 'exportIssue.confirm' }),
        cancelButtonText: this.$t('exportIssue.cancel', { msg: 'exportIssue.cancel' }),
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        deleteRequest(baseUrl_New + `/charger/delrow/${id}`)
        .then(response=>{
            if (response === "删除成功"){
                this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }));
                this.getChargersList();
            } else {
                this.$message.error(this.$t('issue.deleteF', { msg: 'issue.deleteF' }));
            }
        })
      })
      },

      newChargersVisiableFunc(){
        this.resetForm("chargerForm")
        this.newChargersVisiable = true;
      },

      newChargersVisiableFuncClose(){
        this.newChargersVisiable = false;
      },

      addCharger(){
        this.$refs.chargerForm.validate((valid) => { 
        if (valid) {
         postRequest(baseUrl_New + "/charger/insertrow",this.chargerForm,{
          headers: {
            'Content-Type': 'application/json' // 设置请求头为 JSON 格式
          }
         })
         .then(res =>{
            if(res === '新增成功'){
              this.chargerForm.name = '';
              this.chargerForm.companyName = '';
              this.chargerForm.companyID = '';
              this.chargerForm.type = '';
              this.newChargersVisiableFuncClose();
              this.$message.success(this.$t('issue.addS', { msg: 'issue.addS' }));
              this.getChargersList();
            }else{
              this.$message.error(this.$t('issue.addF', { msg: 'issue.addF' }));
            }
          })
        }
      });
    },

    resetForm(formName) {  //重置表单
        if (this.$refs[formName] !== undefined) {
          this.$refs[formName].resetFields();
          this.typeList.splice(0,this.typeList.length); //清空数组
          this.usernameList.splice(0,this.usernameList.length); //清空数组
        }              
      },

      getAllCompany(){ 
      this.companyList.splice(0,this.companyList.length); //清空数组
      getRequest(baseUrl_New + '/company/getlist').then(res => {
        for (let i=0 ;i<res.length;i++){
          this.companyList.push({
            text: res[i].companyname,
            label: res[i].companyname,
            value: res[i].companyID
          });
        }
      });
    },

    companyChange(companyID){
      getRequest(baseUrl_New + '/queryusername/' + companyID).then(res => {
        console.log(res)
        this.usernameList.splice(0,this.usernameList.length); //清空数组
        for(let i = 0;i < res.length;i++){
          this.usernameList.push({
            text: res[i],
            label: res[i],
            value: res[i]
          });
        }
      });

      getRequest(baseUrl_New + '/company/querytype/' + companyID).then(res => {
          this.typeList.splice(0,this.typeList.length); //清空数组
          for(let i =0;i<res.length;i++){
            this.typeList.push({
              text: res[i].name,
              label: res[i].name,
              value: res[i].name
            })
          }
      })
    },

   handelCompanyChange(){
       this.chargerForm.type = ''
       this.chargerForm.name = ''
   },

   reset(){
    this.search = '';
    this.getChargersList();
   },

  }
}
  
  </script>
  
  <style scoped>
  .el-table {
    margin-top: 20px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #fff;
  }
  
  .el-table th,
  .el-table td {
    padding: 12px 16px;
    text-align: center;
  }
  
  .el-table th {
    background-color: #f5f5f5;
  }
  
  .el-table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .el-table-column--selection {
    width: 50px;
  }

  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
  }
  
  </style>